export const openWhatsAppJournalInvite = (trip, name, token) => {
  const url = `${window.location.origin}/journal/${token}`;
  const text = `Hoi ${name}! Volg onze roadtrip "${trip.name}" — elke dag nieuwe foto's, route en verhalen in ons reisdagboek. Kijk mee en reageer gerust (geen account nodig): ${url}\n— via VoltRoute ⚡`;
  window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(text)}`, "_blank", "noopener");
};
